import { Template } from 'sections/onsite-campaigns/types';
import { DomainRule } from '../../types';

export interface SendEmailTemplateRequiredRuleDto {
  template: Template;
}

export const SendEmailTemplateRequiredRuleKey = 'sendEmailTemplateRequired';

/**
 * A template needs to be chosen if a `Send email` message is added to the workflow.
 *
 * @param template
 * @param formStateKey
 * @returns 'fail', with an error message, if no template is chosen. 'pass' if a template is chosen.
 */
export const SendEmailTemplateRequiredRule = (dto: SendEmailTemplateRequiredRuleDto): DomainRule => {
  if (!dto.template?.id) {
    return {
      result: 'fail',
      ruleKey: SendEmailTemplateRequiredRuleKey,
    };
  }

  return {
    result: 'pass',
    ruleKey: null,
  };
};
